
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPublicAllCategories } from '../lib/api';
import '../styles/CategoriesPage.css';

import { Testimonials, StatsBar } from '../components/home/HomeComponents';
import { imgSrc } from '../lib/env';
export default function CategoriesPage() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getPublicAllCategories()
      .then(setCategories)
      .catch(() => setCategories([]));
  }, []);

  // const BASE_URL = "http://localhost/CODIZN-full-project%20(2)/codizn/backend";

  const getImageUrl = (img) => {
    if (!img) return "https://dummyimage.com/600x600/cccccc/000000&text=No+Image";
    if (img.startsWith("http")) return img;
    if (img.includes("/uploads")) return `http://localhost${img}`;
    return `${BASE_URL}/uploads/${img}`;
  };

  return (
    <div className="categories-page">
      <div className="categories-container">
        <h1 className="categories-title">Categories</h1>
        <div className="categories-grid">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/shop?category=${encodeURIComponent(category.name)}`}
              className="category-card"
            >
              <img
                src={imgSrc(category.img) || "https://dummyimage.com/600x600/cccccc/000000&text=No+Image"}
                alt={category.name}
                className="category-img"
                onError={(e) => { e.target.src = "https://dummyimage.com/600x600/cccccc/000000&text=Error"; }}
              />
              <div className="category-overlay" />
              <div className="category-content">
                <div className="category-name">{category.name}</div>
                <div className="category-shop">SHOP COLLECTION</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Testimonials />
      <StatsBar />
    </div>
  );
}